import { render, staticRenderFns } from "./PhysicalStorageChangeAudit.vue?vue&type=template&id=77fe3862&scoped=true&"
import script from "./PhysicalStorageChangeAudit.vue?vue&type=script&lang=js&"
export * from "./PhysicalStorageChangeAudit.vue?vue&type=script&lang=js&"
import style0 from "./PhysicalStorageChangeAudit.vue?vue&type=style&index=0&id=77fe3862&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77fe3862",
  null
  
)

export default component.exports